import { SitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { CookiesProvider, RddkTheme, setGridConfiguration } from 'db-npm-e4sc-rd-ui';
import 'db-npm-e4sc-rd-ui/dist/fonts.css';
import 'db-npm-e4sc-rd-ui/dist/normalize.css';
import 'db-npm-e4sc-rd-ui/dist/styles.css';
// @ts-expect-error React needed for JSX
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { componentFactory } from '../../temp/componentBuilder';

// Configure the Grid in RD UI
setGridConfiguration({ gutterWidth: 24 });

export type AppSetupProps = {
  children?: any;
};

export const AppSetup = ({ children }: AppSetupProps) => {
  return (
    <CookiesProvider>
      <ThemeProvider theme={RddkTheme}>
        <SitecoreContext componentFactory={componentFactory}>{children}</SitecoreContext>
      </ThemeProvider>
    </CookiesProvider>
  );
};
